import React, { Component } from "react"
import ProductCard from "./productCard"
import IndexBanner from "./indexBanner"
import {
  Grid,
  Container,
  List,
  Checkbox,
  Divider,
  Accordion,
  Icon,
  Responsive,
} from "semantic-ui-react"
import StackGrid from "react-stack-grid"
import sizeMe from "react-sizeme"

class ProductsGrid extends Component {
  constructor(props) {
    super(props)
    this.state = { selectedTag: "All", selectedProducts: [], activeIndex: -1 }
  }

  handleClickMenu = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  handleClickCategory = e => {
    this.setState({ selectedTag: e.target.innerText })
    this.filterProducts(e.target.innerText)
  }

  filterProducts = cat => {
    const selectedProducts = this.props.products.edges.filter(
      p => p.node.data.category === cat
    )
    this.setState({ selectedProducts })
  }

  displayProducts = () => {
    return this.state.selectedTag === "All"
      ? this.props.products.edges
      : this.state.selectedProducts
  }

  uniqueCategories = () => {
    let allCategories = this.props.products.edges.map(
      ({ node }) => node.data.category
    )
    let uniqueCategories = Array.from(new Set(allCategories))
    return (uniqueCategories = ["All", ...uniqueCategories])
  }

  calculateWidth = width => {
    if (width <= 480) {
      return "100%"
    } else if (width <= 768) {
      return "33.33%"
    } else {
      return "25%"
    }
  }

  render() {
    const {
      size: { width },
    } = this.props
    const { activeIndex } = this.state
    return (
      <Container>
        <IndexBanner />
        <Divider style={{ marginLeft: "80px", marginRight: "80px" }} />
        <Grid>
          <Grid.Row centered>
            <Responsive as={List} minWidth={768} horizontal relaxed>
              {this.uniqueCategories()
                .sort()
                .map(category => {
                  return (
                    <List.Item key={category}>
                      <Checkbox
                        label={<label>{category}</label>}
                        onClick={this.handleClickCategory}
                        checked={this.state.selectedTag === category}
                        style={{
                          fontSize: "1.3em",
                          fontWeight: "bold",
                          fontFamily: "Saira",
                        }}
                      />
                    </List.Item>
                  )
                })}
            </Responsive>

            <Responsive as={Accordion} maxWidth={768}>
              <Accordion.Title
                active={activeIndex === 0}
                index={0}
                onClick={this.handleClickMenu}
                style={{
                  fontSize: "1.3em",
                  fontWeight: "bold",
                  fontFamily: "Saira",
                  marginTop: "-25px",
                }}
              >
                <Icon name="dropdown" />
                Filter by categories
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 0}>
                <List style={{ textAlign: "left" }}>
                  {this.uniqueCategories()
                    .sort()
                    .map(category => {
                      return (
                        <List.Item key={category}>
                          <Checkbox
                            label={<label>{category}</label>}
                            onClick={this.handleClickCategory}
                            checked={this.state.selectedTag === category}
                            style={{
                              fontSize: "1.3em",
                              fontWeight: "bold",
                              fontFamily: "Saira",
                            }}
                          />
                        </List.Item>
                      )
                    })}
                </List>
              </Accordion.Content>
            </Responsive>
          </Grid.Row>
        </Grid>

        <div style={{ marginBottom: "10px" }}>
          <Responsive as={Container} minWidth={768}>
            <StackGrid
              columnWidth={this.calculateWidth(width)}
              gutterWidth="20"
              monitorImagesLoaded="true"
              duration={0}
            >
              {this.displayProducts().map(({ node }) => {
                return <ProductCard info={node.data} />
              })}
            </StackGrid>
          </Responsive>

          <Responsive as={Container} maxWidth={768}>
            {this.displayProducts().map(({ node }) => {
              return <ProductCard info={node.data} />
            })}
          </Responsive>
        </div>
      </Container>
    )
  }
}

export default sizeMe()(ProductsGrid)
